'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translations = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defineMessages;

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translations = exports.translations = (0, _reactIntl.defineMessages)((_defineMessages = {
  AccountAuthorisationRequiredTitle: {
    id: 'AccountAuthorisationRequiredTitle',
    defaultMessage: 'Account Authorisation Required',
    description: 'Account Authorisation Required Title'
  },
  Addresses: {
    id: 'Addresses',
    defaultMessage: 'Addresses',
    description: 'Addresses'
  },
  AllProvidersFilterAll: {
    id: 'AllProvidersFilterAll',
    defaultMessage: 'All Providers',
    description: 'All Providers'
  },
  AllProvidersFilterLocal: {
    id: 'AllProvidersFilterLocal',
    defaultMessage: 'Local Providers',
    description: 'All Providers Local Providers'
  },
  AllProvidersSearchPlaceholder: {
    id: 'AllProvidersSearchPlaceholder',
    defaultMessage: 'Enter your provider\'s name',
    description: 'All Providers Search Placeholder'
  },
  AllProvidersSearchNoResult: {
    id: 'AllProvidersSearchNoResult',
    defaultMessage: 'No Result found for <b>{text}</b>',
    description: 'All Providers Search No Result Found'
  },
  AlreadyAccount: {
    id: 'AlreadyAccount',
    defaultMessage: 'Already have an account?',
    description: 'Already have an account text'
  },
  Amazon: {
    id: 'Amazon',
    defaultMessage: 'Amazon',
    description: 'Amazon'
  },
  SignInWithApple: {
    id: 'SignInWithApple',
    defaultMessage: 'Sign in with Apple',
    description: 'Sign in with Apple'
  },
  Apple: {
    id: 'Apple',
    defaultMessage: 'Apple',
    description: 'Apple'
  },
  AppleLoginErrorTitle: {
    id: 'AppleLoginErrorTitle',
    defaultMessage: 'Error signing in with Apple',
    description: 'Apple login error title'
  },
  AppleLoginErrorDescription: {
    id: 'AppleLoginErrorDescription',
    defaultMessage: 'An error occurred while trying to sign in to Apple. Please try again later. ',
    description: 'Apple login error description'
  },
  AppleLoginUnavailableTitle: {
    id: 'AppleLoginUnavailableTitle',
    defaultMessage: 'Unable to sign in with Apple',
    description: 'Apple login unavailable error title'
  },
  AppleLoginUnavailableDescription: {
    id: 'AppleLoginUnavailableDescription',
    defaultMessage: 'Apple login is currently unavailable. Please try again later. ',
    description: 'Apple login unavailable error description'
  },
  ApproveAgreementsAccept: {
    id: 'ApproveAgreementsAccept',
    defaultMessage: 'I Accept',
    description: 'Approve Agreements Accept button'
  },
  ApproveAgreementsMessage: {
    id: 'ApproveAgreementsMessage',
    defaultMessage: 'By creating an account, you accept Stingray\'s {termsLink} and {privacyLink}.',
    description: 'Approve Agreements Message'
  },
  ApproveAgreementsTitle: {
    id: 'ApproveAgreementsTitle',
    defaultMessage: 'Agreement',
    description: 'Approve Agreements Title'
  },
  Authorization: {
    id: 'Authorization',
    defaultMessage: 'Authorization',
    description: 'Authorization text'
  },
  AuthorizationError: {
    id: 'AuthorizationError',
    defaultMessage: 'Authorization Error',
    description: 'Authorization Error title'
  },
  AuthorizationErrorMessage: {
    id: 'AuthorizationErrorMessage',
    defaultMessage: 'Please make sure your account is authorized on the Stingray Music mobile app and try again.',
    description: 'Authorization Error message'
  },
  AuthorizationExpiredMessage: {
    id: 'AuthorizationExpiredMessage',
    defaultMessage: 'Please reauthorize your app to keep enjoying Stingray Music.',
    description: 'Authorization Expired message'
  },
  AuthorizationExpiredTitle: {
    id: 'AuthorizationExpiredTitle',
    defaultMessage: 'Access to Stingray Music has expired',
    description: 'Authorization Expired title'
  },
  AuthorizationLater: {
    id: 'AuthorizationLater',
    defaultMessage: 'Authorization Later',
    description: 'Authorization Later text'
  },
  AuthorizationMessage: {
    id: 'AuthorizationMessage',
    defaultMessage: 'Please authorize your account to enjoy unlimited music streaming',
    description: 'Authorization Message text'
  },
  AuthorizationMobileMessage: {
    id: 'AuthorizationMobileMessage',
    defaultMessage: 'Please launch the Stingray Music mobile app and authorize your account. When you\'re done, come back and click OK.',
    description: 'Authorization Mobile Message text'
  },
  AuthorizeNow: {
    id: 'AuthorizeNow',
    defaultMessage: 'Authorize Now',
    description: 'Authorize Now text'
  },
  AuthorizationOptionsMessage: {
    id: 'AuthorizationOptionsMessage',
    defaultMessage: 'Choose how you want to authorize your Stingray Music service.',
    description: 'Authorization Options Message text'
  },
  AuthorizationSSOSuccessMessage: {
    id: 'AuthorizationSSOSuccessMessage',
    defaultMessage: 'You have successfully authorized Stingray Music on this device!\nYou can now listen to Stingray Music as a <b>{provider}</b> subscriber.',
    description: 'Authorization SSO Success Message text'
  },
  AuthorizationWithMobile: {
    id: 'AuthorizationWithMobile',
    defaultMessage: 'Authorize with your mobile app',
    description: 'Authorize Options button mobile app'
  },
  AuthorizationWithProvider: {
    id: 'AuthorizationWithProvider',
    defaultMessage: 'Authorize with <b>{provider}</b>',
    description: 'Authorize Options button SSO'
  },
  BackToWelcomePage: {
    id: 'BackToWelcomePage',
    defaultMessage: 'Go back to home page',
    description: 'Go back to home page'
  },
  Cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel text'
  },
  CaptchaErrorMessage: {
    id: 'CaptchaErrorMessage',
    defaultMessage: 'Invalid Captcha',
    description: 'Captcha Error Message'
  },
  ChangeProvider: {
    id: 'ChangeProvider',
    defaultMessage: 'Change Provider',
    description: 'Change Provider text'
  },
  CommunicationDisclaimer: {
    id: 'CommunicationDisclaimer',
    defaultMessage: 'My consent is sought by Stingray Group Inc. for itself and on behalf of its affiliates, subsidiaries and related entities. I will be able to withdraw such consent at any time. Please refer to Stingray’s {privacyLink} for more details. You can manage your preferences at any time through the Preference Center.<br><br>By clicking <i>Yes I accept</i>, you accept Stingray’s {termsLink} and {privacyLink}',
    description: 'Communication Disclaimer.'
  },
  CommunicationMessage: {
    id: 'CommunicationMessage',
    defaultMessage: 'Would you like to receive {product}\'s tailored newsletters and be informed about special offers, promotions and contests for Stingray\'s products and services?',
    description: 'Communication Message.'
  },
  CommunicationMessageKaraokeTsm: {
    id: 'CommunicationMessageKaraokeTsm',
    defaultMessage: 'Love deals and contests? Sign up for our newsletter, and we’ll send you news to sing about.',
    description: 'Communication Message for Karaoke Tsm.'
  },
  CommunicationSubDisclaimer: {
    id: 'CommunicationSubDisclaimer',
    defaultMessage: 'By clicking on Yes, I accept, you accept Stingray’s {termsLink} and {privacyLink}.',
    description: 'Communication Disclaimer.'
  },
  CommunicationTitle: {
    id: 'CommunicationTitle',
    defaultMessage: 'Communication preferences',
    description: 'Communication Title.'
  },
  ConfirmForgotPasswordMessage: {
    id: 'ConfirmForgotPasswordMessage',
    defaultMessage: 'An email has been sent to <b>{email}</b> with instructions to reset your account password.',
    description: 'Confirm Forgot Password Message.'
  },
  ConfirmForgotPasswordSubMessage: {
    id: 'ConfirmForgotPasswordSubMessage',
    defaultMessage: 'Please follow its instructions to reset your account password.',
    description: 'Confirm Forgot Password Sub Message.'
  },
  ConfirmNewPassword: {
    id: 'ConfirmNewPassword',
    defaultMessage: 'Confirm New Password',
    description: 'Confirm New Password Placeholder.'
  },
  ConfirmPassword: {
    id: 'ConfirmPassword',
    defaultMessage: 'Confirm Password',
    description: 'Confirm Password Placeholder.'
  },
  Congratulations: {
    id: 'Congratulations',
    defaultMessage: 'Congratulations!',
    description: 'Congratulations text'
  },
  ConnectWithMobile: {
    id: 'ConnectWithMobile',
    defaultMessage: 'Connect with mobile app',
    description: 'Connect with your mobile app button.'
  },
  ContactUs: {
    id: 'ContactUs',
    defaultMessage: '<a href="http://www.stingray.com/contact-us#contact-us-email" target="_blank">Contact Us</a>',
    description: 'Contact Us Text'
  },
  ContactUsByEmail: {
    id: 'ContactUsByEmail',
    defaultMessage: 'Contact us by email:',
    description: 'Contact Us by email Text'
  },
  ContactUsByMailAddressCaOnly: {
    id: 'ContactUsByMailAddressCaOnly',
    defaultMessage: '<b>Stingray Group Inc.</b><br>730 Wellington, Montreal,<br>Quebec, Canada H3C 1T4<br><br>',
    description: 'Contact Us By Mail Address Text for the Canada office only'
  },
  ContactUsByMailAddress: {
    id: 'ContactUsByMailAddress',
    defaultMessage: '<b>Stingray Group Inc.</b><br>730 Wellington, Montreal,<br>Quebec, Canada H3C 1T4<br><br>' + '<b>Stingray Music USA Inc.</b><br>6420-A1 Rea Road, Suite 161,<br>Charlotte, North Carolina<br>28277 USA<br><br>' + '<b>Stingray Digital International Limited</b><br>11 Ronald’s Road And 25 Horsell Road,<br>London N5 1XL,<br>United Kingdom<br><br>',
    description: 'Contact Us By Mail Address Text'
  },
  ContactUsFeedback: {
    id: 'ContactUsFeedback',
    defaultMessage: 'Thank you for your feedback.',
    description: 'Contact Us Feedback'
  },
  ContactUsFooter: {
    id: 'ContactUsFooter',
    defaultMessage: 'If you have questions about the privacy aspects of Stingray\'s products or services or would like to make a privacy complaint, ' + 'please contact us by email: {privacyEmail} ' + 'or by mail at any of these street {addresses}.',
    description: 'Contact Us Footer Text'
  },
  ContactUsMaxChars: {
    id: 'ContactUsMaxChars',
    defaultMessage: '{value, number} of {maxValue} max characters',
    description: 'Contact Us Max Chars'
  },
  ContactUsOrByMailAddress: {
    id: 'ContactUsOrByMailAddress',
    defaultMessage: 'or contact by mail',
    description: 'Contact Us Or by mail address text'
  },
  ContactUsTextOnly: {
    id: 'ContactUsTextOnly',
    defaultMessage: 'Contact Us',
    description: 'Contact Us Text Only'
  },
  ContactBusinessSale: {
    id: 'ContactBusinessSale',
    defaultMessage: 'Contact us at <a href="mailto:businesssales@stingray.com?Subject=Webplayer%20Account%20Request" target="_top">businesssales@stingray.com</a> to get an account.',
    description: 'Contact Business Sale Text'
  },
  Continue: {
    id: 'Continue',
    defaultMessage: 'Continue',
    description: 'Continue'
  },
  CreateAccountError: {
    id: 'CreateAccountError',
    defaultMessage: 'The information you\'ve entered is invalid.<br><br>Please try again.',
    description: 'Create Account Error.'
  },
  CreateAccount: {
    id: 'CreateAccount',
    defaultMessage: 'Create Account',
    description: 'Create Account message.'
  },
  CreateAnAccount: {
    id: 'CreateAnAccount',
    defaultMessage: 'Create an account',
    description: 'Create an account message.'
  },
  DontHaveAnAccount: {
    id: 'DontHaveAnAccount',
    defaultMessage: 'Don\'t have a Stingray account?',
    description: 'Don\'t have a Stingray account'
  },
  Email: {
    id: 'Email',
    defaultMessage: 'Email',
    description: 'Email input placeholder'
  },
  EmailAddress: {
    id: 'EmailAddress',
    defaultMessage: 'Email address',
    description: 'EmailAddress input placeholder'
  },
  EmailExistsMessage: {
    id: 'EmailExistsMessage',
    defaultMessage: 'We\'re sorry, that email is taken.',
    description: 'EmailAddress already exists for create account'
  },
  // TODO SVODAPPS-1003 translate
  EnterPassword: {
    id: 'EnterPassword',
    defaultMessage: 'Enter a Password',
    description: 'Enter a Password'
  },
  Error: {
    id: 'Error',
    defaultMessage: 'Error',
    description: 'Error'
  },
  ErrorInvalidCredentialsMessage: {
    id: 'ErrorInvalidCredentialsMessage',
    defaultMessage: 'There was an error with your email/password combination. Please try again.',
    description: 'Invalid Credentials Message'
  },
  ErrorInvalidCredentialsMessageMusic: {
    id: 'ErrorInvalidCredentialsMessageMusic',
    defaultMessage: 'This email/password combination is not recognized.<br>Please try again or sign up to Stingray Music to continue.',
    description: 'Invalid Credentials Message for Stingray Music'
  },
  ErrorInvalidCredentialsTitle: {
    id: 'ErrorInvalidCredentialsTitle',
    defaultMessage: 'Invalid Credentials',
    description: 'Invalid Credentials Title'
  },
  ErrorRetryTitle: {
    id: 'ErrorRetryTitle',
    defaultMessage: 'An error has occurred',
    description: 'Error Retry Title'
  },
  ErrorRetryText: {
    id: 'ErrorRetryText',
    defaultMessage: 'Please try again later',
    description: 'Error Retry Text'
  },
  ExistingAccount: {
    id: 'ExistingAccount',
    defaultMessage: 'Existing Account',
    description: 'Existing Account'
  },
  Facebook: {
    id: 'Facebook',
    defaultMessage: 'Facebook',
    description: 'Facebook'
  },
  FacebookConnectionError: {
    id: 'FacebookConnectionError',
    defaultMessage: 'Facebook Connection Error',
    description: 'Facebook Connection Error Title﻿'
  },
  FirstLogin: {
    id: 'FirstLogin',
    defaultMessage: 'First time logging in?',
    description: 'First time logging in Label.'
  },
  FirstLoginHintMessage: {
    id: 'FirstLoginHintMessage',
    defaultMessage: 'This service requires you to authorize your account with a provider that carries Stingray Music. You can do so by installing the Stingray Music mobile app and signing up.',
    description: 'First Time Login Hint Message.'
  },
  ForgotPassword: {
    id: 'ForgotPassword',
    defaultMessage: 'Forgot your password?',
    description: 'Forgot Password Button Label.'
  },
  ForgotPasswordMessage: {
    id: 'ForgotPasswordMessage',
    defaultMessage: 'Enter your email address and we\'ll send directions on how to reset your password.',
    description: 'Forgot Password Message.'
  },
  FreeTrial: {
    id: 'FreeTrial',
    defaultMessage: 'Free Trial',
    description: 'Free Trial Button.'
  },
  IDontLikeDeals: {
    id: 'IDontLikeDeals',
    defaultMessage: 'I don\'t like deals',
    description: 'I don\'t like deals button'
  },
  InvalidEmail: {
    id: 'InvalidEmail',
    defaultMessage: 'Invalid email address',
    description: 'Invalid email address'
  },
  InvalidRequest: {
    id: 'InvalidRequest',
    defaultMessage: 'Invalid Request',
    description: 'Invalid Request'
  },
  InvalidEmailMessage: {
    id: 'InvalidEmailMessage',
    defaultMessage: 'Please enter a valid email address.',
    description: 'Invalid Email Message'
  },
  LinkAccountFree: {
    id: 'LinkAccountFree',
    defaultMessage: 'Listen to free* music online with your Stingray account',
    description: 'Link Account Free Text.'
  },
  LinkAccountSubTitlePart1: {
    id: 'LinkAccountSubTitlePart1',
    defaultMessage: 'Your account with',
    description: 'Link Account SubTitle Part 1.'
  },
  LinkAccountSubTitlePart2: {
    id: 'LinkAccountSubTitlePart2',
    defaultMessage: 'grants you access to Stingray Music!',
    description: 'Link Account SubTitle Part 2.'
  },
  LinkAccountWhyText: {
    id: 'LinkAccountWhyText',
    defaultMessage: 'Why do I need a Stingray account?',
    description: 'Link Account Why Text.'
  },
  LinkAccountWhyExplanation: {
    id: 'LinkAccountWhyExplanation',
    defaultMessage: 'Stingray Music is now offered on multiple platforms! Enjoy your favorite music on mobile, web and TV by signing up for a Stingray account.',
    description: 'Link Account Why Explanation.'
  },
  LinkExpiredText: {
    id: 'LinkExpiredText',
    defaultMessage: 'This link has expired.<br><br>Please try again.',
    description: 'Link Expired Text.'
  },
  ListAllProviders: {
    id: 'ListAllProviders',
    defaultMessage: 'List All Providers',
    description: 'List All Providers Label.'
  },
  Login: {
    id: 'Login',
    defaultMessage: 'Log In',
    description: 'Login Label.'
  },
  LoginTitle: {
    id: 'LoginTitle',
    defaultMessage: 'Log in to {product}',
    description: 'Login Title.'
  },
  LoginWithEmail: {
    id: 'LoginWithEmail',
    defaultMessage: 'Log in with email',
    description: 'Login In with email Label.'
  },
  LoginWithFacebook: {
    id: 'LoginWithFacebook',
    defaultMessage: 'Connect with Facebook',
    description: 'Facebook Login Button Label'
  },
  LogoutText: {
    id: 'LogoutText',
    defaultMessage: 'Log Out',
    description: 'Log Out button text'
  },
  MusicLoginWithPremiumSubTitle: {
    id: 'MusicLoginWithPremiumSubTitle',
    defaultMessage: 'If you’re a subscriber to the premium version of the Stingray Music app, log in below.',
    description: 'Login With Premium SubTitle'
  },
  MusicLoginWithPremiumTitle: {
    id: 'MusicLoginWithPremiumTitle',
    defaultMessage: 'Already Premium?',
    description: 'Login With Premium Title'
  },
  MusicLoginSignUpFooterTitle: {
    id: 'MusicLoginSignUpFooterTitle',
    defaultMessage: 'Let the music play!\n',
    description: 'Music LoginSignUp Footer Title.'
  },
  MusicLoginSignUpFooterHelper: {
    id: 'MusicLoginSignUpFooterHelper',
    defaultMessage: '*If you’d like access to the web player through the Stingray Music app, you must download the app and then upgrade to the premium version.',
    description: 'Music LoginSignUp Footer Helper.'
  },
  MusicLoginSignUpTitle: {
    id: 'MusicLoginSignUpTitle',
    defaultMessage: 'Stream Music Your Way',
    description: 'Music LoginSignUp Title.'
  },
  MusicLoginSignUpSubTitle: {
    id: 'MusicLoginSignUpSubTitle',
    defaultMessage: 'To enjoy the web player, please sign up with your Stingray Music provider or subscribe to the premium version of the Stingray Music app.*',
    description: 'Music LoginSignUp SubTitle.'
  },
  MusicPremiumOnlyErrorSubTitle: {
    id: 'MusicPremiumOnlyErrorSubTitle',
    defaultMessage: 'We\'re sorry, but this service is only currently available for premium members.\nPlease upgrade through the mobile app by downloading it below.',
    description: 'Message displayed when the user has a free account and try to login in webplayer or smart speaker'
  },
  MusicPremiumOnlyErrorTitle: {
    id: 'MusicPremiumOnlyErrorTitle',
    defaultMessage: 'This service is only available for premium members',
    description: 'Title displayed when the user has a free account and try to login in webplayer or smart speaker'
  },
  MusicSignUpFooterSubTitle: {
    id: 'MusicSignUpFooterSubTitle',
    defaultMessage: 'You can still enjoy the web player by downloading the app from Google Play or the App Store and then upgrading to the Premium version.',
    description: 'Music SignUp Footer SubTitle.'
  },
  MusicSignUpFooterTitle: {
    id: 'MusicSignUpFooterTitle',
    defaultMessage: 'Don’t Have a TV Provider?',
    description: 'Music SignUp Footer Title.'
  },
  MusicSignUpSubTitle: {
    id: 'MusicSignUpSubTitle',
    defaultMessage: 'If your TV provider offers Stingray Music, sign up below.',
    description: 'Music SignUp SubTitle.'
  },
  MusicFreeAccessWithProvider: {
    id: 'MusicFreeAccessWithProvider',
    defaultMessage: 'Free access with TV provider',
    description: 'Access for free with a Provider.'
  },
  MusicSignUpWithProviderSubTitle: {
    id: 'MusicSignUpWithProviderSubTitle',
    defaultMessage: 'If your provider offers Stingray Music, get premium access by signing up below.',
    description: 'Sign Up With Provider SubTitle.'
  },
  MusicSignUpWithProviderTitle: {
    id: 'MusicSignUpWithProviderTitle',
    defaultMessage: 'Sign Up With Provider',
    description: 'Sign Up With Provider Title.'
  },
  NewPassword: {
    id: 'NewPassword',
    defaultMessage: 'New Password',
    description: 'New Password Placeholder.'
  },
  NewUser: {
    id: 'NewUser',
    defaultMessage: 'Are you a new user?',
    description: 'New user string to navigate to sign up.'
  },
  NoEmailOnFacebookAccountMessage: {
    id: 'NoEmailOnFacebookAccountMessage',
    defaultMessage: 'This Facebook has no email',
    description: 'No Email On Facebook Account Popup Title'
  },
  NoEmailOnFacebookAccountTitle: {
    id: 'NoEmailOnFacebookAccountTitle',
    defaultMessage: 'No Email ',
    description: 'No Email On Facebook Account Popup Title'
  },
  NoFacebookAccountMessage: {
    id: 'NoFacebookAccountMessage',
    defaultMessage: 'This Facebook account is not yet authorised to use this service.<br>Please sign up to Stingray Music to continue',
    description: 'No Facebook Account Popup Message'
  },
  NotFoundTitle: {
    id: 'NotFoundTitle',
    defaultMessage: 'ERROR 404',
    description: 'Not found Title'
  },
  NotFoundSubTitle: {
    id: 'NotFoundSubTitle',
    defaultMessage: 'The page you\'re looking for doesn\'t exist or was moved.',
    description: 'Not found subtitle'
  },
  NotFoundReason1: {
    id: 'NotFoundReason1',
    defaultMessage: 'If you arrived on this page by following a link from this website, you can tell an administrator.',
    description: 'Not found reason 1'
  },
  NotFoundReason2: {
    id: 'NotFoundReason2',
    defaultMessage: 'If you typed the address in your browser directly, please check that it is spelt correctly.',
    description: 'Not found reason 2'
  },
  SmartSpeakerLoginSignUpFooterTitle: {
    id: 'SmartSpeakerLoginSignUpFooterTitle',
    defaultMessage: 'Don\'t have an account?\n',
    description: 'smart speaker LoginSignUp Footer Title.'
  },
  SmartSpeakerLoginSignUpFooter: {
    id: 'SmartSpeakerLoginSignUpFooter',
    defaultMessage: 'Please sign up through our mobile app by downloading it below.\n',
    description: 'smart speaker LoginSignUp Footer.'
  },
  NotFoundReason3: {
    id: 'NotFoundReason3',
    defaultMessage: 'If this page was in your bookmarks, its address probably changed since. You can use the search feature to find its new location.',
    description: 'Not found reason 3'
  },
  NoThanks: {
    id: 'NoThanks',
    defaultMessage: 'No, Thanks',
    description: 'No thanks text'
  },
  NotSubscribed: {
    id: 'NotSubscribed',
    defaultMessage: 'Not a subscriber yet?',
    description: 'Not Subscribed text'
  },
  Ok: {
    id: 'Ok',
    defaultMessage: 'OK',
    description: 'Ok text.'
  },
  Or: {
    id: 'Or',
    defaultMessage: 'or',
    description: 'or text.'
  },
  OrContinueWith: {
    id: 'OrContinueWith',
    defaultMessage: '- Or continue with -',
    description: 'or continue with text.'
  },
  OrLoginWith: {
    id: 'OrLoginWith',
    defaultMessage: '- or log in with -',
    description: 'or log in with text.'
  },
  Password: {
    id: 'Password',
    defaultMessage: 'Password',
    description: 'Password input placeholder'
  },
  PasswordMinError: {
    id: 'PasswordMinError',
    defaultMessage: 'Password must be at least 8 characters long.',
    description: 'Password minimum character not reach error '
  },
  PasswordMatchError: {
    id: 'PasswordMatchError',
    defaultMessage: 'Both passwords must be identical.',
    description: 'Password must match error '
  },
  PasswordResetMessage: {
    id: 'PasswordResetMessage',
    defaultMessage: 'Please enter a new password below.',
    description: 'Password Reset Message.'
  },
  PasswordResetTitle: {
    id: 'PasswordResetTitle',
    defaultMessage: 'Password Reset',
    description: 'Password ResetTitle Title.'
  },
  PopupInvalidResetPasswordMessage: {
    id: 'PopupInvalidResetPasswordMessage',
    defaultMessage: 'New Password and Confirm Password fields do not match.',
    description: 'Invalid Password Reset Message.'
  },
  // TODO SVODAPPS-1003 create translations
  CreatePasswordAndLinkToProfile: {
    id: 'CreatePasswordAndLinkToProfile',
    defaultMessage: 'Create a Password',
    description: 'Create Password Title'
  },
  CreatePasswordAndLinkToProfileMessage: {
    id: 'CreatePasswordAndLinkToProfileMessage',
    defaultMessage: 'Please enter a password below.',
    description: 'Create Password and Link to Profile Message'
  },
  CreatePasswordAndLinkToProfileError: {
    id: 'CreatePasswordAndLinkToProfileError',
    defaultMessage: 'An error occurred while creating the password.',
    description: 'Create Password and Link to Profile Error Message'
  },
  CreatePasswordAndLinkToProfileSuccess: {
    id: 'CreatePasswordAndLinkToProfileSuccess',
    defaultMessage: 'Thank you for creating your Stingray password. You can now enjoy {product} on available platforms.',
    description: 'Create Password and Link to Profile Success Message'
  },
  Karaoke: {
    id: 'Karaoke',
    defaultMessage: 'Karaoke',
    description: 'Karaoke'
  },
  KaraokeTSM: {
    id: 'KaraokeTSM',
    defaultMessage: 'Singing Machine',
    description: 'Singing Machine'
  },
  PrivacyEmail: {
    id: 'PrivacyEmail',
    defaultMessage: 'privacy@stingray.com',
    description: 'Privacy Email.'
  },
  PrivacyMailToSubject: {
    id: 'PrivacyMailToSubject',
    defaultMessage: 'Stingray Music Privacy Policy',
    description: 'Privacy Mail To Subject.'
  },
  PrivacyPolicy: {
    id: 'PrivacyPolicy',
    defaultMessage: 'Privacy Policy',
    description: 'Privacy Policy Text.'
  },
  PrivacyPolicyLink: {
    id: 'PrivacyPolicyLink',
    defaultMessage: '<a href="{link}" target="_blank">Privacy Policy</a>',
    description: 'Privacy Policy Link.'
  },
  PrivacyPolicyUrl: {
    id: 'PrivacyPolicyUrl',
    defaultMessage: 'https://legal.stingray.com/en/privacy-policy',
    description: 'Privacy Policy Url.'
  },
  ProviderNotListed: {
    id: 'ProviderNotListed',
    defaultMessage: 'My provider is not listed',
    description: 'Provider Not Listed.'
  },
  ProviderNotListedEmail: {
    id: 'ProviderNotListedEmail',
    defaultMessage: 'Hi,\n\nI listen to Stingray Music with {providerName} and would like to get access to the free webplayer/mobile service.\n\nThank you.',
    description: 'Provider Not Listed Email Body'
  },
  ProviderNotListedEmailSubject: {
    id: 'ProviderNotListedEmailSubject',
    defaultMessage: 'Provider not listed',
    description: 'Provider Not Listed Email Subject'
  },
  ProviderNotListedMessage: {
    id: 'ProviderNotListedMessage',
    defaultMessage: 'Please feel free to contact Stingray Customer Support at <a href="mailto:musicsupport@stingray.com?Subject=Provider not listed">musicsupport@stingray.com</a>.',
    description: 'Provider Not Listed Message.'
  },
  ProviderNotListedTitle: {
    id: 'ProviderNotListedTitle',
    defaultMessage: 'Provider not in the list?',
    description: 'Provider Not Listed Title.'
  },
  ProvidersTitle: {
    id: 'ProvidersTitle',
    defaultMessage: 'Providers',
    description: 'Providers Title.'
  },
  QRCodeReload: {
    id: 'QRCodeReload',
    defaultMessage: 'Click to reload the code',
    description: 'QR Code reload text.'
  },
  QRLogin: {
    id: 'QRLogin',
    defaultMessage: 'Connect with mobile app',
    description: 'Login Label.'
  },
  QRLoginStep1: {
    id: 'QRLoginStep1',
    defaultMessage: 'Open the <span>Stingray Music app</span> on your <span>mobile device</span>',
    description: 'Step 1 of QR Login'
  },
  QRLoginStep2Part1: {
    id: 'QRLoginStep2Part1',
    defaultMessage: 'Tap the <span>Settings icon </span>',
    description: 'Step 2 of QR Login'
  },
  QRLoginStep2Part2: {
    id: 'QRLoginStep2Part2',
    defaultMessage: ' and select <span>Web Player Access</span>',
    description: 'Step 2 of QR Login'
  },
  QRLoginStep3: {
    id: 'QRLoginStep3',
    defaultMessage: '<span>Scan</span> this code with the Stingray Music app',
    description: 'Step 3 of QR Login'
  },
  QRSignUp: {
    id: 'QRSignUp',
    defaultMessage: 'Sign Up with mobile app',
    description: 'Sign Up Label.'
  },
  QRSignUpStep1: {
    id: 'QRSignUpStep1',
    defaultMessage: '<span>Download</span> the Stingray Music mobile app and <span>Sign Up</span>',
    description: 'Step 1 of QR Sign Up'
  },
  RememberMe: {
    id: 'RememberMe',
    defaultMessage: 'Keep me logged in',
    description: 'Remember Me label'
  },
  RequiredField: {
    id: 'RequiredField',
    defaultMessage: 'Required field',
    description: 'Required Field'
  },
  ResetPasswordConfirmationTitle: {
    id: 'ResetPasswordConfirmationTitle',
    defaultMessage: 'Password reset confirmation',
    description: 'Reset Password Confirmation Title'
  },
  ResetPasswordConfirmationMessage: {
    id: 'ResetPasswordConfirmationMessage',
    defaultMessage: 'Your password has been reset.',
    description: 'Reset Password Confirmation Message'
  },
  ResetPasswordConfirmationSubMessage: {
    id: 'ResetPasswordConfirmationSubMessage',
    defaultMessage: 'Please click OK and return to the {product} web player to enter your new password.',
    description: 'Reset Password Confirmation Sub Message'
  },
  ResetPasswordConfirmationSubMessageMobile: {
    id: 'ResetPasswordConfirmationSubMessageMobile',
    defaultMessage: 'You may now return to the {product} application to enter your new password.',
    description: 'Reset Password Confirmation Sub Message for Mobile'
  },
  ResetPasswordConfirmationCTA: {
    id: 'ResetPasswordConfirmationCTA',
    defaultMessage: 'Log in',
    description: 'Reset Password Confirmation CTA button'
  },
  ResetPasswordExpiredMessage: {
    id: 'ResetPasswordExpiredMessage',
    defaultMessage: 'This reset link has expired.',
    description: 'Reset Password Expired Message'
  },
  ResetPasswordExpiredSubMessage: {
    id: 'ResetPasswordExpiredSubMessage',
    defaultMessage: 'Please try again to receive a new link.',
    description: 'Reset Password Expired Sub Message'
  },
  ResetPasswordExpiredTitle: {
    id: 'ResetPasswordExpiredTitle',
    defaultMessage: 'Link Expired',
    description: 'Reset Password Expired Title.'
  },
  Retry: {
    id: 'Retry',
    defaultMessage: 'Retry',
    description: 'Retry text'
  },
  Send: {
    id: 'Send',
    defaultMessage: 'Send',
    description: 'Send text'
  },
  SignUp: {
    id: 'SignUp',
    defaultMessage: 'Sign Up',
    description: 'Sign Up Button Label'
  },
  SignUpFreeMode: {
    id: 'SignUpFreeMode',
    defaultMessage: 'Sign Up Free',
    description: 'Music SignUpFreeMode Button.'
  },
  SignUpProvider: {
    id: 'SignUpProvider',
    defaultMessage: 'Sign Up With Provider',
    description: 'Music SignUpProvider Button.'
  },
  SignUpTitle: {
    id: 'SignUpTitle',
    defaultMessage: 'Sign Up with {product}',
    description: 'Sign Up Title {product} is replace by the product name'
  },
  SignUpWithEmail: {
    id: 'SignUpWithEmail',
    defaultMessage: 'Sign Up with email',
    description: 'Sign up with email Label.'
  },
  Submit: {
    id: 'Submit',
    defaultMessage: 'Submit',
    description: 'Submit Button Label'
  },
  Success: {
    id: 'Success',
    defaultMessage: 'Success',
    description: 'Success title'
  },
  StartDayTrialTitle: {
    id: 'StartDayTrialTitle',
    defaultMessage: 'Start your {nb}-day FREE trial',
    description: 'Start Day Trial Title'
  },
  StartDayTrialMessage: {
    id: 'StartDayTrialMessage',
    defaultMessage: 'and authorize later',
    description: 'Start Day Trial Message'
  },
  StartStingrayMusic: {
    id: 'StartStingrayMusic',
    defaultMessage: 'Start Stingray Music',
    description: 'Start Stingray Music'
  },
  StingrayAccount: {
    id: 'StingrayAccount',
    defaultMessage: 'Stingray Account',
    description: 'Stingray Account'
  },
  StingrayFamilyDescription: {
    id: 'StingrayFamilyDescription',
    defaultMessage: 'Stingray Music is part of the Stingray family of multiplatform music products and services.<br>' + '<br>Create one account to access all Stingray products and services.',
    description: 'Stingray Family Description Label'
  },
  StingrayBusiness: {
    id: 'StingrayBusiness',
    defaultMessage: 'Stingray Business',
    description: 'Stingray Business'
  },
  StingrayClassica: {
    id: 'StingrayClassica',
    defaultMessage: 'Stingray Classica',
    description: 'Stingray Classica'
  },
  StingrayQello: {
    id: 'StingrayQello',
    defaultMessage: 'Stingray Qello',
    description: 'Stingray Qello'
  },
  SmartSpeakerStingrayMusic: {
    id: 'SmartSpeakerStingrayMusic',
    defaultMessage: 'your Stingray Music Account',
    description: 'Stingray Music'
  },
  StingrayMusic: {
    id: 'StingrayMusic',
    defaultMessage: 'Stingray Music',
    description: 'Stingray Music'
  },
  StingrayMusicFreeExplanation: {
    id: 'StingrayMusicFreeExplanation',
    defaultMessage: '* Always free with your subscription to a provider that carries Stingray Music.',
    description: 'Stingray Music Free Explanation Label'
  },
  SwitchProviderChangeMessage: {
    id: 'SwitchProviderChangeMessage',
    defaultMessage: 'You can change your provider at any time in the <b>Settings</b> page',
    description: 'Switch Provider Change Message'
  },
  SwitchProviderContinueButton: {
    id: 'SwitchProviderContinueButton',
    defaultMessage: 'Continue with this provider',
    description: 'Switch Provider Continue Button'
  },
  SwitchProviderMessage: {
    id: 'SwitchProviderMessage',
    defaultMessage: 'Your Stingray account is already linked with <b>{provider}</b>',
    description: 'Switch Provider Message'
  },
  SwitchProviderSwitchButton: {
    id: 'SwitchProviderSwitchButton',
    defaultMessage: 'Switch to this provider',
    description: 'Switch Provider Switch Button'
  },
  TermsAndPrivacy: {
    id: 'TermsAndPrivacy',
    defaultMessage: 'By creating an account, you accept Stingray\'s {lineBreak} {terms} and {privacy}',
    description: 'Terms And Privacy label'
  },
  TermsConditions: {
    id: 'TermsConditions',
    defaultMessage: 'Terms and Conditions',
    description: 'Terms and Conditions text.'
  },
  TermsConditionsLink: {
    id: 'TermsConditionsLink',
    defaultMessage: '<a href="{link}" target="_blank"> Terms & Conditions</a>',
    description: 'Terms and Conditions Link.'
  },
  TermsConditionsClassicaUrl: {
    id: 'TermsConditionsClassicaUrl',
    defaultMessage: 'https://legal.stingray.com/en/classica-terms-and-conditions',
    description: 'Terms and Conditions Url.'
  },
  TermsConditionsQelloUrl: {
    id: 'TermsConditionsQelloUrl',
    defaultMessage: 'https://legal.stingray.com/en/classica-terms-and-conditions', // TODO SVODAPPS-1827 change to use qello terms and conditions
    description: 'Terms and Conditions Url.'
  },
  TermsConditionsUrl: {
    id: 'TermsConditionsUrl',
    defaultMessage: 'https://legal.stingray.com/en/terms-and-conditions',
    description: 'Terms and Conditions Url.'
  },
  TopProvidersMessage: {
    id: 'TopProvidersMessage',
    defaultMessage: 'Please select your provider.',
    description: 'Top Provider sMessage'
  },
  TrialAuthorizationMessage: {
    id: 'TrialAuthorizationMessage',
    defaultMessage: 'To keep enjoying your free access to Stingray Music, please authorize your app.',
    description: 'Trial Authorization Message.'
  },
  TrialExpiredTitle: {
    id: 'TrialExpiredTitle',
    defaultMessage: 'Your trial period has ended',
    description: 'Trial Expired Title.'
  },
  TryAgain: {
    id: 'TryAgain',
    defaultMessage: 'Try Again',
    description: 'Try Again Button.'
  },
  TVCodeExpiryPopupTitle: {
    id: "TVCodeExpiryPopupTitle",
    defaultMessage: "Oops, your code expired!",
    description: "TV Code Expiry Popup Title"
  },
  TVCodeExpiryPopupSubtitle: {
    id: "TVCodeExpiryPopupSubtitle",
    defaultMessage: "Your code is only valid for 1 hour. Please get a new code from your TV and enter it below.",
    description: "TV Code Expiry Popup Subtitle"
  },
  TVCodeExpiryPopupCTA: {
    id: "TVCodeExpiryPopupCTA",
    defaultMessage: "Validate new code",
    description: "TV Code Expiry Popup CTA"
  },
  TVCodeFormTitle: {
    id: "TVCodeFormTitle",
    defaultMessage: "Enter your code",
    description: "TV Code Form Title Message"
  },
  TVCodeFormSubmitButton: {
    id: "TVCodeFormSubmitButton",
    defaultMessage: "Next",
    description: "TV Code Form Submit Button"
  },
  TVCodeFormSubtitle: {
    id: "TVCodeFormSubtitle",
    defaultMessage: "Enter the code displayed on your TV app.",
    description: "TV Code Form Subtitle Message"
  },
  TVCodeFormSuccessTitle: {
    id: "TVCodeFormSuccessTitle",
    defaultMessage: "Login Successful!",
    description: "TV Code Form Success Title"
  },
  TVCodeFormSuccessSubtitle: {
    id: "TVCodeFormSuccessSubtitle",
    defaultMessage: "You are now logged in. Go back to the {product} app to start singing.",
    description: "TV Code Form Success Subtitle"
  },
  TVCodeFormFailureTitle: {
    id: "TVCodeFormFailureTitle",
    defaultMessage: "An error has occurred",
    description: "TV Code Form Failure Title"
  },
  TVCodeFormFailureSubtitle: {
    id: "TVCodeFormFailureSubtitle",
    defaultMessage: "Please try again later.",
    description: "TV Code Form Failure Subtitle"
  },
  TVCodeFormInvalidCode: {
    id: "TVCodeFormInvalidCode",
    defaultMessage: "The code you've entered isn't valid. Please verify it and try again.",
    description: "TV Code Form Invalid Code"
  },
  TVCodeFormNoResponse: {
    id: "TVCodeFormNoResponse",
    defaultMessage: "An error has occurred.",
    description: "TV Code Form No Response"
  },
  TVCodeFormSuccessSubtitleClassica: {
    id: "TVCodeFormSuccessSubtitleClassica",
    defaultMessage: "Go back to Stingray Classica on your TV to experience breathtaking masterpieces.",
    description: "TV Code Form Success Subtitle Classica"
  },
  TVCodeFormSuccessSubtitleMusic: {
    id: "TVCodeFormSuccessSubtitleMusic",
    defaultMessage: "Go back to Stingray Music on your TV to tune in to your favorite channels.",
    description: "TV Code Form Success Subtitle Music"
  },
  TVCodeFormSuccessSubtitleQello: {
    id: "TVCodeFormSuccessSubtitleQello",
    defaultMessage: "Go back to Qello Concerts on your TV for your front-row seat to top concerts.",
    description: "TV Code Form Success Subtitle Qello"
  },
  TVCodeFormSuccessSubtitleKaraoke: {
    id: "TVCodeFormSuccessSubtitleKaraoke",
    defaultMessage: "Go back to Stingray Karaoke on your TV to start singing.",
    description: "TV Code Form Success Subtitle Karaoke"
  },
  UniversalLoginTitle: {
    id: 'UniversalLoginTitle',
    defaultMessage: 'Welcome to {product}',
    description: 'Universal Login Title.'
  },
  UniversalLoginStingrayMusicSubTitle: {
    id: 'UniversalLoginStingrayMusicSubTitle',
    defaultMessage: 'Listen to free* music online now!',
    description: 'Universal Login SubTitle.'
  },
  UnknownError: {
    id: 'UnknownError',
    defaultMessage: 'Unknown server error',
    description: 'Unknown Error text'
  },

  UseAnotherEmail: {
    id: 'UseAnotherEmail',
    defaultMessage: 'Use another email',
    description: 'Use another email text.'
  },
  Username: {
    id: 'Username',
    defaultMessage: 'Username',
    description: 'Username input placeholder'
  },
  WelcomeMusicBusinessTitle: {
    id: 'WelcomeMusicBusinessTitle',
    defaultMessage: 'Welcome to<br>the Stingray Business Web Player',
    description: 'Business Welcome Page Title'
  },

  WelcomeMusicBusinessDescription: {
    id: 'WelcomeMusicBusinessDescription',
    defaultMessage: 'Improve your customer experience with hundreds of channels designed for businesses like yours!',
    description: 'Business Welcome Page Description'
  },

  WelcomeMusicBusinessEnterUserNamePass: {
    id: 'WelcomeMusicBusinessEnterUserNamePass',
    defaultMessage: 'Enter the username and password received in your onboarding email',
    description: 'Business Welcome Page Enter Username and Password'
  },
  WelcomePage: {
    id: 'WelcomePage',
    defaultMessage: 'Welcome page',
    description: 'Welcome Page String'
  },
  WhyAuthorize: {
    id: 'WhyAuthorize',
    defaultMessage: 'Why do I need to authorize?',
    description: 'Why Authorize text'
  },
  WhyAuthorizeReason: {
    id: 'WhyAuthorizeReason',
    defaultMessage: 'Stingray Music is offered through a partnership with {value}. Please authorize your product to gain access to unlimited music streaming.',
    description: 'Why Authorize Reason text'
  },
  YesIAccept: {
    id: 'YesIAccept',
    defaultMessage: 'Yes, I accept',
    description: 'Yes I accept button'
  },
  YesIWantIn: {
    id: 'YesIWantIn',
    defaultMessage: 'Yes, I want in!',
    description: 'Yes I want in button'
  },
  // START Do not translate these language
  de: {
    id: 'de',
    defaultMessage: 'Deutsch',
    description: 'German'
  },
  en: {
    id: 'en',
    defaultMessage: 'English',
    description: 'English'
  },
  es: {
    id: 'es',
    defaultMessage: 'Español',
    description: 'Spanish'
  },
  fi: {
    id: 'fi',
    defaultMessage: 'Suomi',
    description: 'Finnish'
  },
  fr: {
    id: 'fr',
    defaultMessage: 'Français',
    description: 'French'
  },
  hu: {
    id: 'hu',
    defaultMessage: 'Magyar',
    description: 'Hungarian'
  },
  nb: {
    id: 'nb',
    defaultMessage: 'Norsk Bokmål',
    description: 'Norwegian'
  },
  nl: {
    id: 'nl',
    defaultMessage: 'Nederlands',
    description: 'Dutch'
  },
  pt: {
    id: 'pt',
    defaultMessage: 'Português',
    description: 'Portuguese'
  },
  tr: {
    id: 'tr',
    defaultMessage: 'Türkçe',
    description: 'Turkish'
  },
  // END do not translate these language
  LoginWithAmazon: {
    id: 'LoginWithAmazon',
    defaultMessage: 'Login with Amazon',
    description: 'Login with Amazon'
  },
  SignInWithGoogle: {
    id: 'SignInWithGoogle',
    defaultMessage: 'Sign in with Google',
    description: 'Sign in with Google'
  },
  Google: {
    id: 'Google',
    defaultMessage: 'Google',
    description: 'Google'
  },
  GoogleLoginErrorTitle: {
    id: 'GoogleLoginErrorTitle',
    defaultMessage: 'Error signing in with Google',
    description: 'Google login error title'
  },
  GoogleLoginErrorDescription: {
    id: 'GoogleLoginErrorDescription',
    defaultMessage: 'An error occurred while trying to sign in to Google. Please try again later. ',
    description: 'Google login error description'
  },
  GoogleLoginUnavailableTitle: {
    id: 'GoogleLoginUnavailableTitle',
    defaultMessage: 'Unable to sign in with Google',
    description: 'Google login unavailable error title'
  },
  GoogleLoginUnavailableDescription: {
    id: 'GoogleLoginUnavailableDescription',
    defaultMessage: 'Google login is currently unavailable. Please try again later. ',
    description: 'Google login unavailable error description'
  },
  ExpertlyCurated: {
    id: 'ExpertlyCurated',
    defaultMessage: 'EXPERTLY CURATED',
    description: ''
  },
  OnTheGo: {
    id: 'OnTheGo',
    defaultMessage: 'ON THE GO',
    description: ''
  },
  UnlimitedSkips: {
    id: 'UnlimitedSkips',
    defaultMessage: 'UNLIMITED SKIPS',
    description: ''
  }
}, (0, _defineProperty3.default)(_defineMessages, 'StingrayAccount', {
  id: 'StingrayAccount',
  defaultMessage: 'Stingray Account',
  description: 'Title of the existing account page'
}), (0, _defineProperty3.default)(_defineMessages, 'ExistingAccountEmail', {
  id: 'ExistingAccountEmail',
  defaultMessage: 'This email ',
  description: 'Label with the email of the user that tries to sign up'
}), (0, _defineProperty3.default)(_defineMessages, 'EmailAlreadyAssociated', {
  id: 'EmailAlreadyAssociated',
  defaultMessage: ' is already associated with another Stingray service',
  description: 'Label mentioning the email that is already associated with a Stingray account'
}), (0, _defineProperty3.default)(_defineMessages, 'PleaseLoginWithExistingAccount', {
  id: 'PleaseLoginWithExistingAccount',
  defaultMessage: 'Please log in with your existing account or use another email',
  description: 'The please login with your existing account.'
}), (0, _defineProperty3.default)(_defineMessages, 'ContactSupport', {
  id: 'ContactSupport',
  defaultMessage: 'Please feel free to contact Stingray Customer Support at {contactUsEmail}',
  description: 'The please login with your existing account.'
}), (0, _defineProperty3.default)(_defineMessages, 'MaintenanceTitle', {
  id: 'MaintenanceTitle',
  defaultMessage: 'Maintenance in progress',
  description: 'Maintenance banner title'
}), (0, _defineProperty3.default)(_defineMessages, 'MaintenanceDescription', {
  id: 'MaintenanceDescription',
  defaultMessage: 'We’re currently undergoing maintenance and some services may not be available.',
  description: 'Maintenance banner description'
}), _defineMessages));


//////////////////
// WEBPACK FOOTER
// ./src/helpers/DefaultString.js
// module id = 16
// module chunks = 0